import React from "react";

const NotFound = ({ message = "404 � Seite nicht gefunden" }: { message?: string }) => (
  <h1>{message}</h1>
);

export default NotFound;
